export const styleJoin = {
    inputStyle: { backgroundColor: '#d6d6d6',
        color: '#333' },
    buttonStyle: { pointerEvents: 'all',
        cursor: 'pointer' },
    h6Style: { color: '#666' },
    h4Style: { marginTop: '1%',
        marginBottom: '4%',
        color: '#000' },
    joinMargin: {
        marginTop: '65px',
        marginBottom: '34px'
    }


};
